import React from 'react';
import { useDispatch } from 'react-redux';
import type { IRootDispatch } from '../../../../store/models';

import SearchTileGrid from './SearchTileGrid';
import { tiles, tilesDesktopHomePage } from './SearchGridTiles';
import { ISearchTile } from '../SearchTile/SearchTile.types';
import { useResponsiveEffect } from '../../../../hooks';
import { SEARCH_ROUTE } from '../../../../route-names';

export default function SearchTileGridContainer({
  params,
}) {
  const is = useResponsiveEffect();
  const dispatch = useDispatch<IRootDispatch>();

  const handleTileSearch = (tile: ISearchTile) => {
    dispatch.route.go({
      route: SEARCH_ROUTE,
      params: {
        ...tile.searchParams,
        ...params,
        source: 'search_tiles',
      },
      notify: true,
    });
  };

  return (
    <SearchTileGrid
      tiles={(is.mobile || is.tablet) ? tiles : tilesDesktopHomePage}
      onSelectTile={handleTileSearch}
    />
  );
}
